import React from "react";
import { useNavigate } from "react-router-dom";

function valueClass(field, value) {
  if (field !== "change_1d") return "";
  return value >= 0 ? "pos" : "neg";
}

function formatValue(field, value, suffix) {
  const sign = field === "change_1d" && value > 0 ? "+" : "";
  return `${sign}${Number(value).toFixed(2)}${suffix}`;
}

export default function SummaryCard({ title, icon, items, field, suffix }) {
  const nav = useNavigate();
  const testKey = title.toLowerCase().replace(/ /g, "-");
  return (
    <div className="bg-[#0f0f0f] p-4">
      <div className="flex items-center gap-2 mb-3">
        {icon}
        <span className="micro-label">{title}</span>
      </div>
      <ul className="space-y-1.5">
        {items.map((it) => (
          <li
            key={it.symbol}
            onClick={() => nav(`/stock/${it.symbol}`)}
            className="flex items-center justify-between cursor-pointer hover:bg-white/5 px-1 py-0.5"
            data-testid={`summary-${testKey}-${it.symbol}`}
          >
            <span className="font-mono-data text-sm">{it.symbol}</span>
            <span className={`font-mono-data text-sm ${valueClass(field, it[field])}`}>
              {formatValue(field, it[field], suffix)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
